<div class="mb-3">
  <label *ngIf="label" [ngClass]="{'required': required}" [for]="identifier" style="inline-size: max-content">{{ label }}</label>
  <textarea [id]="identifier" class="form-control"
            [(ngModel)]="value" name="nome"
            [maxlength]="maxlength ? maxlength : null"
            [disabled]="disabled" [readonly]="disabled" [required]="required"
            [rows]="rows"
            [ngClass]="{ 'is-invalid': form && (form.submitted || form.controls[name]?.touched || form.controls[name]?.dirty) && form.controls[name]?.errors}"></textarea>
  <validation-errors [form]="form" [controlName]="name"></validation-errors>
</div>
